// extracted by mini-css-extract-plugin
module.exports = {"more_button":"NewsPage-module--more_button--yEvaw","see_more_container":"NewsPage-module--see_more_container--1-g7T"};